import React, { useEffect } from "react";
import { Dimensions, Image, Text, TouchableOpacity, View, } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles'
const isSmallDevice = Dimensions.get('window').width < 767


const useStyles = CreateResponsiveStyle(
    {

        footerContainerStyle: {
            flexDirection: "row",
            flexWrap: "wrap",
            width: "100%",
            flex: 1.2,
            display: "flex",
        },
        footerFirstViewStyle: {
            backgroundColor: "#ffffff",
            flex: 0.4,
            marginTop: "5%",
        },
        contactUsTextStyle: {
            fontFamily: "Inter",
            fontSize: 17,
            fontWeight: "normal",
            fontStyle: "normal",
            lineHeight: 14.4,
            letterSpacing: 0,
            textAlign: "left",
            color: "#999999",
            paddingLeft: "15%",
        },
        idfcBankTextStyle: {
            fontFamily: "Inter",
            fontSize: 18,
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: 22.2,
            letterSpacing: 0,
            textAlign: "left",
            color: "#9d1d27",
            paddingLeft: "15%",
            paddingTop: 20,
        },
        helpLineTextStyle: {
            fontFamily: "Inter",
            fontSize: 17,
            fontWeight: "normal",
            fontStyle: "normal",
            lineHeight: 22.2,
            letterSpacing: 0,
            textAlign: "left",
            color: "#999999",
            paddingLeft: "15%",
        },
        ffBenefitsTextStyle: {
            fontFamily: "Inter",
            fontSize: 23,
            fontWeight: "normal",
            fontStyle: "normal",
            lineHeight: 22.2,
            letterSpacing: 0,
            textAlign: "left",
            color: "#ffffff",
            paddingLeft: "10%",
        },
        benefitsDescTextStyle: {
            fontFamily: "Inter",
            fontSize: 15,
            fontWeight: "100",
            fontStyle: "normal",
            lineHeight: 20,
            letterSpacing: 0.2,
            textAlign: "left",
            color: "#ffffff",
            paddingLeft: "10%",
            paddingTop: 10,
        },
        footerSecondViewStyle: {
            backgroundColor: "#9d1d27",
            flex: 0.6,
            paddingTop: "5%",
        },
        npciImageStyle: {
            width: 200.6,
            height: 45.1,
            marginTop: 20,
            marginLeft: "14%",
        },

    },

    {
        [DEVICE_SIZES.LG]: {

            footerContainerStyle: {
                flexDirection: "row",
                flexWrap: "wrap",
                width: "100%",
                flex: 1.2,
                display: "flex",
            },
            contactUsTextStyle: {
                fontFamily: "Inter",
                fontSize: 17,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 14.4,
                letterSpacing: 0,
                textAlign: "left",
                color: "#999999",
                paddingLeft: "15%",
            },
            idfcBankTextStyle: {
                fontFamily: "Inter",
                fontSize: 18,
                fontWeight: "600",
                fontStyle: "normal",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9d1d27",
                paddingLeft: "15%",
                paddingTop: 20,
            },
            helpLineTextStyle: {
                fontFamily: "Inter",
                fontSize: 17,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#999999",
                paddingLeft: "15%",
            },
            ffBenefitsTextStyle: {
                fontFamily: "Inter",
                fontSize: 23,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#ffffff",
                paddingLeft: "10%",
            },
            benefitsDescTextStyle: {
                fontFamily: "Inter",
                fontSize: 15,
                fontWeight: "100",
                fontStyle: "normal",
                lineHeight: 14,
                letterSpacing: 0.2,
                textAlign: "left",
                color: "#ffffff",
                paddingLeft: "10%",
                paddingTop: 10,
            },
            footerFirstViewStyle: {
                backgroundColor: "#ffffff",
                flex: 0.4,
                marginTop: "5%",
            },
            footerSecondViewStyle: {
                backgroundColor: "#9d1d27",
                flex: 0.6,
                paddingTop: "5%",
            },
            npciImageStyle: {
                width: 200.6,
                height: 45.1,
                marginTop: 20,
                marginLeft: "14%",
            },


        },
        [DEVICE_SIZES.MD]: {

            footerContainerStyle: {
                flexDirection: "row",
                flexWrap: "wrap",
                width: "100%",
                flex: 1.5,
                display: "flex",
            },
            contactUsTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 14.4,
                letterSpacing: 0,
                textAlign: "left",
                color: "#999999",
                paddingLeft: "15%",
            },
            idfcBankTextStyle: {
                fontFamily: "Inter",
                fontSize: 13,
                fontWeight: "600",
                fontStyle: "normal",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9d1d27",
                paddingLeft: "15%",
                paddingTop: 10,
            },
            helpLineTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#999999",
                paddingLeft: "15%",
            },
            ffBenefitsTextStyle: {
                fontFamily: "Inter",
                fontSize: 16,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#ffffff",
                paddingLeft: "10%",
            },
            benefitsDescTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "100",
                fontStyle: "normal",
                lineHeight: 14,
                letterSpacing: 0.2,
                textAlign: "left",
                color: "#ffffff",
                paddingLeft: "10%",
                paddingTop: 10,
            },

            footerFirstViewStyle: {
                backgroundColor: "#ffffff",
                flex: 0.5,
                marginTop: "5%",
            },
            footerSecondViewStyle: {
                backgroundColor: "#9d1d27",
                flex: 0.5,
                paddingTop: "5%",
            },
            npciImageStyle: {
                width: 136.6,
                height: 34.1,
                marginTop: 20,
                marginLeft: "14%",
            },

        },
        [DEVICE_SIZES.SM]: {

            footerContainerStyle: {
                flexDirection: "column",
                flexWrap: "wrap",
                width: "100%",
                flex: 1.5,
                display: "flex",
            },
            contactUsTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 14.4,
                letterSpacing: 0,
                textAlign: "left",
                color: "#999999",
                paddingLeft: "15%",
            },
            idfcBankTextStyle: {
                fontFamily: "Inter",
                fontSize: 13,
                fontWeight: "600",
                fontStyle: "normal",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9d1d27",
                paddingLeft: "15%",
                paddingTop: 10,
            },
            helpLineTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#999999",
                paddingLeft: "15%",
            },
            ffBenefitsTextStyle: {
                fontFamily: "Inter",
                fontSize: 16,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#ffffff",
                paddingLeft: "10%",
            },
            benefitsDescTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "100",
                fontStyle: "normal",
                lineHeight: 14,
                letterSpacing: 0.2,
                textAlign: "left",
                color: "#ffffff",
                paddingLeft: "10%",
                paddingTop: 10,
            },

            footerFirstViewStyle: {
                backgroundColor: "#ffffff",
                flex: 0.5,
                marginTop: "5%",
            },
            footerSecondViewStyle: {
                backgroundColor: "#9d1d27",
                flex: 0.5,
                paddingTop: "5%",
            },
            npciImageStyle: {
                width: 136.6,
                height: 34.1,
                marginTop: 20,
                marginLeft: "14%",
            },

        },
        [DEVICE_SIZES.XS]: {
            
            footerContainerStyle: {
                flexDirection: "column-reverse",
                flexWrap: "wrap",
                width: "100%",
                flex: 1.5,
                display: "flex",
                marginTop: 0,
            },
            contactUsTextStyle: {
                fontFamily: "Inter",
                fontSize: 14,
                lineHeight: 14.4,
                letterSpacing: 0,
                textAlign: "left",
                color: "#999999",
                paddingLeft: 0,
            },
            idfcBankTextStyle: {
                fontFamily: "Inter",
                fontSize: 14,
                fontWeight: "600",
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#9d1d27",
                paddingLeft: 0,
                paddingTop: 10,
            },
            helpLineTextStyle: {
                fontFamily: "Inter",
                fontSize: 11,
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "left",
                color: "#999999",
                paddingLeft: 0,
            },
            ffBenefitsTextStyle: {
                fontFamily: "Inter",
                fontSize: 14,
                lineHeight: 22.2,
                letterSpacing: 0,
                textAlign: "center",
                color: "#ffffff",
                paddingLeft: 0,
            },
            benefitsDescTextStyle: {
                fontFamily: "Inter",
                fontSize: 11,
                fontWeight: "100",
                fontStyle: "normal",
                lineHeight: 14,
                letterSpacing: 0.2,
                textAlign: "center",
                color: "#ffffff",
                paddingLeft: 0,
                paddingTop: 10,
                paddingLeft: 5,
            },

            footerFirstViewStyle: {
                backgroundColor: "#ffffff",
                flex: 0.5,
                marginTop: "5%",
                alignItems: "center",
                justifyContent: "center",
            },
            footerSecondViewStyle: {
                backgroundColor: "#9d1d27",
                flex: 0.5,
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 20,
            },
            npciImageStyle: {
                width: 156.6,
                height: 44.1,
                marginTop: 20,
                marginLeft: 0,
            },


        },
    }
);

export default useStyles;